﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederFarBarnDto from '../Models/VeilederFarBarnDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { EpiAppState } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';

const rootReducer = combineReducers<VeilederFarBarnAppState>({
    valg: valgReducer,
    epiContext: (
        state: EpiContext<VeilederFarBarnDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederFarBarnDto>,
    ): EpiContext<VeilederFarBarnDto> => epiContextReducer(state, action),
});

export type VeilederFarBarnAppState = EpiAppState<VeilederFarBarnDto> & {
    valg: ReturnType<typeof valgReducer>;
};

export default function configureStore(): Store<VeilederFarBarnAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
